'use client';

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogPanel } from '@headlessui/react';
import { BadgeShareContent } from '@src/components/BadgeShare/BadgeShareContent';
import { ModalBackdrop } from '@src/components/Modal/ModalBackdrop';
import { cn } from '@src/utils/tailwind';
export interface BadgeShareModalProps {
  isOpen: boolean;
  badge: GamificationApi.Badge | null;
  initialDetail?: GamificationApi.Badge;
  onClose: () => void;
}
export function BadgeShareModal(t0) {
  const $ = _c(10);
  const {
    isOpen,
    badge,
    initialDetail,
    onClose
  } = t0;
  if (!badge) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ModalBackdrop className="bg-bodi-black-text/60 backdrop-blur-sm" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("relative mx-auto max-h-[90vh] w-[min(484px,calc(100vw-2rem))] overflow-hidden rounded-[30px] shadow-md transition-all", "data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-150 data-enter:ease-out data-leave:duration-150 data-leave:ease-in data-closed:lg:translate-y-0 data-closed:lg:scale-95", "lg:h-[804px] lg:max-h-[804px] lg:w-[484px] lg:max-w-[484px]");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== badge || $[3] !== initialDetail || $[4] !== onClose) {
    t3 = <div className="fixed inset-0 z-max flex items-center justify-center overflow-y-auto p-4 lg:p-10"><DialogPanel transition={true} className={t2}><BadgeShareContent badge={badge} initialDetail={initialDetail} onClose={onClose} /></DialogPanel></div>;
    $[2] = badge;
    $[3] = initialDetail;
    $[4] = onClose;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isOpen || $[7] !== onClose || $[8] !== t3) {
    t4 = <Dialog open={isOpen} onClose={onClose} className="relative z-max">{t1}{t3}</Dialog>;
    $[6] = isOpen;
    $[7] = onClose;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}